var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 10.2677L16.32 7.39501C16.8128 6.98728 16.5578 6.18774 15.9123 6.15387L11.4246 5.8816C11.1524 5.86434 10.9146 5.69433 10.8124 5.43933L9.16284 1.22384C8.92511 0.628838 8.0917 0.628838 7.85397 1.22384L6.20511 5.42267C6.10284 5.67767 5.86511 5.84767 5.59284 5.86494L1.08784 6.13721C0.442363 6.17108 0.187363 6.96994 0.680108 7.37769L4.16511 10.2339C4.36897 10.4039 4.47124 10.6927 4.40284 10.9477L3.26397 15.3166C3.11124 15.9288 3.77397 16.4216 4.31784 16.0816L8.10901 13.6504C8.34673 13.4976 8.63628 13.4976 8.85673 13.6504L12.6644 16.0816C13.2083 16.4216 13.8717 15.9288 13.7183 15.3166L12.5794 10.9642C12.5289 10.7099 12.6139 10.4377 12.835 10.2677Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fe53db4d7b1654ca50605e8610ec77c2.svg";
export { ForwardRef as ReactComponent };